module.exports = __webpack_public_path__ + "static/media/world-background.691898eb.png";